import React from "react";

import { Stack, Typography, Avatar } from "@mui/material";
import { Link } from "../buttons";

export interface OrganizerInfoInterFace {
  title: string;
  name: string;
  textColor: string;
  ManAvatar: any;
  onMessageClick: () => void;
}

const OrganizerInfo = ({ title, name, textColor, ManAvatar, onMessageClick }: OrganizerInfoInterFace) => {
  return (
    <Stack direction="row" spacing={2}>
      <Avatar alt="Remy Sharp" src={ManAvatar} sx={{ width: 56, height: 56 }} />
      <Stack justifyContent="center">
        <Typography variant="h4" fontWeight={400} className={`font-${textColor}`} >
          {title}
        </Typography>
        <Typography variant="h6" fontWeight={400} className={`font-${textColor}`}>
          {name}
          <Link label="Message" onClick={onMessageClick} color="primary" fontSize={15} />
        </Typography>
      </Stack>
    </Stack>
  );
};
export default OrganizerInfo;
